module.exports = __webpack_public_path__ + "static/img-mobile-shipping-zones@3x.8ef595ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-mobile-shipping-zones@3x.png
// module id = 252
// module chunks = 65120233804887 218122631423814